module.exports = __webpack_public_path__ + "static/media/image14.4d739afb.png";